import React from 'react';
import { RadioButton, RadioButtonGroup } from '../../../components/ui';
import { Controller, useFormContext } from 'react-hook-form';

export default function PausePreferences() {
  const { control } = useFormContext();
  return (
    <div
      className="flex items-center"
      style={{ fontSize: 13, flexDirection: 'column' }}
    >
      <Controller
        control={control}
        name="pauseDuration"
        render={({ field }) => {
          return (
            <RadioButtonGroup
              style={{ width: 'auto' }}
              value={field.value}
              onChange={field.onChange}
            >
              <RadioButton value={3}>3 Months</RadioButton>
              <RadioButton value={6}>6 Months</RadioButton>
              <RadioButton value={12}>1 Year</RadioButton>
            </RadioButtonGroup>
          );
        }}
      />
    </div>
  );
}
